import {
  Component,
  Injector,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ActivitiesServiceProxy,
  ActivityDaysServiceProxy,
  CloneActivityDayInput,
  FormsServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

@Component({
  selector: 'app-clone-activities-modal',
  templateUrl: './clone-activity.modal.component.html',
  styleUrls: ['./clone-activity.modal.component.less'],
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
})
export class CloneActivityModalComponent
  extends AppComponentBase
  implements OnInit, AfterViewInit {
  saving = false;

  disabledDays: string[];
  showCalendar = false;
  daysSelected: string[] = [];
  activityDayId = null;
  copyWithData=false;
  isDynamicForm = false;
  formBody: any;
  @Output() afterActivityCloned: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('cloneActivityModal', { static: true }) modal: ModalDirective;

  isSelected = (event: any) => {
    const date =
      event.getFullYear() +
      '-' +
      ('00' + (event.getMonth() + 1)).slice(-2) +
      '-' +
      ('00' + event.getDate()).slice(-2);

    if (this.disabledDays.find((x) => x == date)) {
      return 'disabled';
    } else if (this.daysSelected.find((x) => x == date)) {
      return 'selected';
    } else {
      return null;
    }
  };

  constructor(
    injector: Injector,
    private _activitiesServiceProxy: ActivitiesServiceProxy,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private _formServiceProxy: FormsServiceProxy,
    private _notify: NotifyService,
    private _tokenAuth: TokenAuthServiceProxy,
    private _activatedRoute: ActivatedRoute
  ) {
    super(injector);
  }

  selectDate(event: any, calendar: any) {
    const date =
      event.getFullYear() +
      '-' +
      ('00' + (event.getMonth() + 1)).slice(-2) +
      '-' +
      ('00' + event.getDate()).slice(-2);
    const index = this.daysSelected.findIndex((x) => x == date);
    if (index < 0) this.daysSelected.push(date);
    else this.daysSelected.splice(index, 1);

    calendar.updateTodaysDate();
  }

  shown() {
    this.showCalendar = true;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  close() {
    this.modal.hide();
    this.showCalendar = false;
  }

  save() {
    this.saving = true;

    if (this.isDynamicForm){

      this.daysSelected.forEach(day => {
      this._formServiceProxy.cloneForm(day, this.copyWithData, this.formBody).subscribe(
        () => {
          this.afterActivityCloned.emit();
  
          this.saving = false;
          this.showCalendar = false;
          this.daysSelected = [];
          this.disabledDays = [];
  
          this.close();
        },
        () => {
          this.saving = false;
        }
      );
    })

      this.isDynamicForm = false;
      this.formBody = []
    }
    else{
    const params = new CloneActivityDayInput({
      activityDayId: this.activityDayId,
      cloneToDays: this.daysSelected.map((day) => moment(day)),
      copyWithData:this.copyWithData,
    });

    this._activityDaysServiceProxy.cloneActivityDay(params).subscribe(
      () => {
        this.afterActivityCloned.emit();

        this.saving = false;
        this.showCalendar = false;
        this.daysSelected = [];
        this.disabledDays = [];

        this.close();
      },
      () => {
        this.saving = false;
      }
    );
    }
  }
}
